<template>
  <v-app>
    <v-app-bar app color="#7B6C6C" dark >   <!-- #AB377A magenta -->
      <v-img src="./assets/IFX_LOGO_White.png" max-height="44" max-width="100" aspect-ratio="1.7"> </v-img>

      <v-toolbar-title class="px-6">Actor-of-Trust // {{$router.currentRoute.name}}</v-toolbar-title>

      <v-spacer></v-spacer>
      <div class="px-3">- Welcome {{!$store.state.user ? 'Stranger' : $store.state.user.toUpperCase()}}! -</div>
      
      <v-icon v-if="!$store.state.token">mdi-import</v-icon>

      <v-tooltip bottom v-if="$router.currentRoute.name === 'Security Control Center'">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="$router.push({name: 'Application Control Center'})"><v-icon>mdi-pencil-box-outline</v-icon></v-btn>
        </template> 
        Application Control Center
      </v-tooltip>

      <v-tooltip bottom v-if="$router.currentRoute.name === 'Application Control Center'">
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="$router.push({name: 'Security Control Center'})"><v-icon>mdi-shield-outline</v-icon></v-btn>
        </template> 
        Security Control Center
      </v-tooltip>

      <v-tooltip bottom v-if="$store.state.token">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click.prevent="logout"><v-icon>mdi-export</v-icon></v-btn>
        </template> 
        Logout
      </v-tooltip>
    </v-app-bar> 


    <br> 

    <v-content min-width=700>
      <transition name="fade">
        <router-view />
      </transition>
    </v-content>

    <v-footer absolute class="font-weight-medium" dense color="#BEB4B6">
      <v-col class="text-right" cols="12" align-self="center">
        <div style="color:white">&copy;2020 - Infineon Technologies AG</div>
      </v-col>
    </v-footer>
  </v-app>
</template>



<script>
export default {
  name: 'App',

  data: () => ({
  }),

  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push({ name: 'Home' });
    }
  }
};

</script>
